import { Route, Routes } from "react-router-dom";
import MechanistPericiaList from "./pericia-list/pericia-list-mechanic.component";
// import MechanicPericiaUpdate from "./pericia-update/pericia-update-mechanic.component";
import RepairRecordsListComponent from "./repair-records/repair-records.component";
import { ListRepairRecordsByUserIdPage } from "../../../pages/repair-records/list-repair-records-by-user-id.page";
import { MechanicUpdatePericiaPage } from "../../../pages/pericia/mechanic-update-pericia.page";
import RepairRecordsListByDateComponent from "./repair-records/repair-records-by-date.component";
import { ACCESS_RULES } from "../../../shared/auth/access-control";
import RoleProtectedRoute from "../../protected/role-protected-route.component";

const MechanicPericiasRoute = () => {
  return (
    <Routes>
      <Route path="/list" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.MECHANIC_PERICIAS}><MechanistPericiaList /></RoleProtectedRoute>} />
      {/* <Route path=":periciaID" element={<MechanicPericiaUpdate />} /> */}
      <Route path=":id" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.MECHANIC_PERICIAS}><MechanicUpdatePericiaPage /></RoleProtectedRoute>} />
      <Route path="/repair-records" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.MECHANIC_PERICIAS}><RepairRecordsListComponent /></RoleProtectedRoute>} />
      <Route path="/repair-records/date" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.MECHANIC_PERICIAS}><RepairRecordsListByDateComponent /></RoleProtectedRoute>} />
      <Route path="/repair-records2" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.MECHANIC_PERICIAS}><ListRepairRecordsByUserIdPage /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default MechanicPericiasRoute;
